// extracted by mini-css-extract-plugin
export default {"card":"VideoCard_card__AHqfg","content":"VideoCard_content__Rpu5N","video":"VideoCard_video__L40q8","title":"VideoCard_title__j90L+"};